import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { LoadingSpaceType } from 'src/app/core/services/import-export-service-types';
import { ProjectService } from 'src/app/core/services/project.service';
import { CargoSpace } from '../../../../core/types';
import { Project } from '../../../../core/objects/project';

@Component({
    selector: 'gl-loading-space-description',
    templateUrl: './loading-space-description.component.html',
    styleUrls: ['./loading-space-description.component.scss'],
    standalone: false
})
export class LoadingSpaceDescriptionComponent implements OnInit {
  public cargoSpaces: CargoSpace[];
  public currentWorkSpaceIndex: number;
  public cargoSpaceName: string;
  public isSet: boolean;
  public displayWorkspaceIndex = null;
  public isClosed = false;
  public workspacesCount = 1;
  @Input() public workSpaceIndex: number | null = null;
  @Input() public project: Project = null;
  @Output() public isClosedEvent = new EventEmitter<boolean>();

  constructor(private projectService: ProjectService) {}

  public collapse(): void {
    this.isClosed = !this.isClosed;
    this.isClosedEvent.emit(this.isClosed);
  }

  /** Pallet deck height only — must not grow with loaded layers. */
  public getPalletBaseHeight(cargoSpace: CargoSpace): number {
    return cargoSpace?.extraFeatures?.palletHeight ?? 0;
  }

  public get replicatedPalletQuantity(): number {
    const cargoSpace = this.cargoSpaces?.[0];
    const quantity = cargoSpace?.extraFeatures?.palletQuantity ?? 0;
    if (cargoSpace?.type !== LoadingSpaceType.Pallet || quantity <= 1) {
      return 0;
    }
    return quantity;
  }

  public ngOnInit() {
    if (this.project === null) {
      this.displayWorkspaceIndex = this.workSpaceIndex !== null ? this.workSpaceIndex + 1 : 1;
      this.projectService.currentWorkSpaceIndex.subscribe((currentWorkSpaceIndex: number) => {
        this.currentWorkSpaceIndex = this.workSpaceIndex
          ? this.workSpaceIndex
          : currentWorkSpaceIndex;
      });
      this.projectService.project.subscribe((project) => {
        this.workspacesCount = project.workSpaces.length;
        if (project.workSpaces.length === 0) {
          return;
        }
        this.cargoSpaces = project.workSpaces[this.currentWorkSpaceIndex].cargoSpaces;
        this.cargoSpaceName = _.get(this.cargoSpaces[0], 'name');
        this.isSet = project.workSpaces[this.currentWorkSpaceIndex].cargoSpaces.length === 2;
      });
    } else {
      this.displayWorkspaceIndex = this.workSpaceIndex !== null ? this.workSpaceIndex + 1 : 1;
      this.cargoSpaces = this.project.workSpaces[this.workSpaceIndex].cargoSpaces;
      this.cargoSpaceName = _.get(this.cargoSpaces[0], 'name');
      this.isSet = this.project.workSpaces[this.workSpaceIndex].cargoSpaces.length === 2;
    }
  }
}
